import { css, cx } from "@emotion/css";
import { ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

type DetailLayoutBoxProps = {
  children: ReactNode;
  className?: string;
  isTogglerVisible?: boolean;
};

export function DetailLayoutBox({
  children,
  className,
  isTogglerVisible,
}: DetailLayoutBoxProps) {
  const classes = createStyles(useTheme());
  return (
    <div
      className={cx(classes.root, className, {
        [classes.isTogglerVisible]: isTogglerVisible,
      })}
    >
      {children}
    </div>
  );
}

function createStyles({ borderRadius, spacing }: Theme) {
  return {
    root: css({
      width: "100%",
      padding: spacing([2, 3]),
      backgroundColor: white,
      borderTopLeftRadius: borderRadius.huge,
      borderTopRightRadius: borderRadius.huge,
    }),
    isTogglerVisible: css({
      paddingBottom: spacing(20),
    }),
  };
}
